import { render, staticRenderFns } from "./DeliveryBlockDeliveryAddress.vue?vue&type=template&id=1fb6c01b&"
import script from "./DeliveryBlockDeliveryAddress.vue?vue&type=script&lang=js&"
export * from "./DeliveryBlockDeliveryAddress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports